function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M30 60C13.431 60 0 46.569 0 30 0 13.431 13.431 0 30 0c16.569 0 30 13.431 30 30a30 30 0 01-30 30zm0-56C15.64 4 4 15.64 4 30s11.64 26 26 26 26-11.64 26-26A26 26 0 0030 4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.925 17.368H17.007c-2.422.019-4.375 1.975-4.375 4.382v15.754c0 2.406 1.953 4.363 4.375 4.381h11.714l10.67 6.121c.254.182.59.202.864.052a.802.802 0 00.415-.754v-5.452h2.323c2.409-.019 4.357-1.955 4.375-4.348V21.75c0-2.42-1.974-4.382-4.409-4.382h-.034zM22.528 31.784H18.42v-4.08h4.107v4.08zm9.492 0h-4.107v-4.08h4.107v4.08zm9.492 0h-4.107v-4.08h4.14v4.08h-.033z"
}));

function SvgChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgChat;